import React from 'react';
import PropTypes from 'prop-types';
import Layout from 'antd/lib/layout';
import Menu from 'antd/lib/menu';
import Icon from 'antd/lib/icon';
import { translate } from 'react-i18next';
import { MenuItemLink } from '../../../common/components';

const Sidebar = ({ onChangeLayout, questionCount, isAdmin, t }) => (



  <Menu mode="horizontal" align="right" onClick={() => onChangeLayout()}>
    { isAdmin &&
      <MenuItemLink to="/admin/dashboard">
        <Icon type="home" /> {t('Dashboard')}
      </MenuItemLink>
    }
    <MenuItemLink to="/admin/accounts">
      <Icon type="user" /> {t('Používatelia')}
    </MenuItemLink>
    <MenuItemLink to="/admin/loans">
      <Icon type="file-text" /> {t('Pôžičky')}
    </MenuItemLink>
    <MenuItemLink to="/admin/allocations">
      <Icon type="file-text" /> {t('Investície')}
    </MenuItemLink>
    <MenuItemLink to="/admin/dispose">
      <Icon type="shopping-cart" /> {t('Odpredaj pohľadávok')}
    </MenuItemLink>
    <MenuItemLink to="/admin/payments">
      <Icon type="credit-card" /> {t('Platby')}
    </MenuItemLink>
    <MenuItemLink to="/admin/messaging">
      <Icon type="message" /> {t('Emaily a SMS')}
    </MenuItemLink>
    { isAdmin &&
      <MenuItemLink to="/admin/settings">
        <Icon type="setting" /> {t('Nastavenie systému')}
      </MenuItemLink>
    }
    { isAdmin &&
      <MenuItemLink to="/admin/administrators">
        <Icon type="user" /> {t('Administrátori')}
      </MenuItemLink>
    }
    <MenuItemLink to="/admin/exports">
      <Icon type="export" /> {t('Exporty')}
    </MenuItemLink>
    { isAdmin &&
      <MenuItemLink to="/admin/transactions/all">
        <Icon type="sync" /> {t('Transakcie')}
      </MenuItemLink>
    }
    { isAdmin &&
      <MenuItemLink to="/admin/transactions/pending">
        <Icon type="sync" /> {t('Čakajúce Transakcie')}
      </MenuItemLink>
    }
    { isAdmin &&
      <MenuItemLink to="/admin/provision-fee/withdraw">
        <Icon type="wallet" /> {t('Výber poplatkov')}
      </MenuItemLink>
    }
    <MenuItemLink to="/admin/help">
      {
        questionCount.total > 0 ?
          <p className="unanswered"><Icon type="file-text" /> {t('Otázky ')}<span className="numberOfQuestions">{questionCount.total}</span></p> :
          <p><Icon type="file-text" /> {t('Otázky')}</p>
      }
    </MenuItemLink>
  </Menu>

);

Sidebar.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  questionCount: PropTypes.object.isRequired,
};

export default translate()(Sidebar);



// WEBPACK FOOTER //
// ./src/features/admin/components/Sidebar.js